// extracted by mini-css-extract-plugin
module.exports = {"container":"assigned-agents-container__36Qqv","list":"assigned-agents-list__3rNXJ","unassigned":"assigned-agents-unassigned__FuIDw","item":"assigned-agents-item__1NeES"};